import { fileFormatRuleType } from 'components/contents/Models/EditableMenu/PopoverRule/Modal/RuleModal/ExportingUsersAndGroupsModal/types';
import env from 'config/settings';

export const sampleRightsFileLink = `${env.API}/example_import_users.xlsx`;

export const formatRuleItems: Array<{ name: string; value: fileFormatRuleType }> = [
  { name: 'XLSX', value: 'xlsx' },
  { name: 'CSV', value: 'csv' },
];
